import React from "react";
import { Phone, Mail, ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";

export default function Footer({ site }) {
    const phoneTel = site.phone_raw || site.phone.replace(/\s+/g, "");
    return (
        <footer data-testid="site-footer" className="relative bg-ink-900 border-t border-white/10">
            {/* Giant type CTA band */}
            <div className="mx-auto max-w-[1400px] px-5 md:px-10 py-20 md:py-28">
                <a
                    href={`tel:${phoneTel}`}
                    data-testid="footer-call-mega"
                    className="block group"
                >
                    <div className="font-mono-label text-lime-signal mb-6">Call or text — free estimate</div>
                    <div className="font-display uppercase text-[16vw] md:text-[10vw] leading-[0.85] text-chrome group-hover:text-lime-signal transition-colors">
                        {site.phone}
                    </div>
                </a>
            </div>

            <div className="h-hairline mx-5 md:mx-10" />

            <div className="mx-auto max-w-[1400px] px-5 md:px-10 py-12 grid grid-cols-12 gap-8">
                <div className="col-span-12 md:col-span-4 flex items-start gap-3">
                    <img src={site.logo_url} alt={site.business_name} className="w-14 h-14 object-contain" />
                    <div>
                        <div className="font-display text-2xl leading-none">{site.business_name}</div>
                        <div className="font-mono-label text-white/50 mt-2">Licensed &amp; insured · North AL</div>
                    </div>
                </div>

                <div className="col-span-6 md:col-span-3">
                    <div className="font-mono-label text-white/40 mb-3">Services</div>
                    <ul className="space-y-2 text-white/80 text-sm">
                        {site.services.slice(0, 6).map((s) => (
                            <li key={s.id}>{s.title}</li>
                        ))}
                    </ul>
                </div>

                <div className="col-span-6 md:col-span-3">
                    <div className="font-mono-label text-white/40 mb-3">Service area</div>
                    <ul className="space-y-2 text-white/80 text-sm">
                        {(site.service_areas || []).slice(0, 6).map((a) => (
                            <li key={a}>{a}, AL</li>
                        ))}
                    </ul>
                </div>

                <div className="col-span-12 md:col-span-2">
                    <div className="font-mono-label text-white/40 mb-3">Contact</div>
                    <ul className="space-y-3 text-sm">
                        <li>
                            <a href={`tel:${phoneTel}`} data-testid="footer-call" className="inline-flex items-center gap-2 text-white/80 hover:text-lime-signal">
                                <Phone size={13} /> {site.phone}
                            </a>
                        </li>
                        <li>
                            <a href={`mailto:${site.email}`} data-testid="footer-email" className="inline-flex items-center gap-2 text-white/80 hover:text-lime-signal">
                                <Mail size={13} /> {site.email}
                            </a>
                        </li>
                        <li>
                            <Link to="/login" data-testid="footer-admin" className="inline-flex items-center gap-2 text-white/40 hover:text-lime-signal">
                                Admin <ArrowUpRight size={12} />
                            </Link>
                        </li>
                    </ul>
                </div>
            </div>

            <div className="border-t border-white/10">
                <div className="mx-auto max-w-[1400px] px-5 md:px-10 py-6 flex flex-wrap items-center justify-between gap-4 font-mono-label text-white/40">
                    <div>© {new Date().getFullYear()} {site.business_name}. All rights reserved.</div>
                    <div>Designed for North Alabama · Site v1.0</div>
                </div>
            </div>
        </footer>
    );
}
